module.exports = __webpack_public_path__ + "img/rec-15.5ffad418.jpg";